// Selectors for TentativeParents state
export const getTentativeParents = (state) => (
  state.tentativeParents ? state.tentativeParents.tentativeParents || [] : []
)
export const getTentativeParentsFeedback = (state) => (
  state.tentativeParents ? state.tentativeParents.feedback || {} : {}
)
export const getTentativeParentsLoading = (state) => (
  state.tentativeParents && state.tentativeParents.feedback
    ? state.tentativeParents.feedback.requesting || false
    : false
)
export const getTentativeParentsError = (state) => (
  state.tentativeParents && state.tentativeParents.feedback
    ? state.tentativeParents.feedback.error || false
    : false
)

// Search selectors
export const getTentativeParentsSearchResults = (state) => (
  state.tentativeParents ? state.tentativeParents.searchResults || [] : []
)
export const getTentativeParentsSearchFeedback = (state) => (
  state.tentativeParents ? state.tentativeParents.searchFeedback || {} : {}
)
export const getTentativeParentsSearchLoading = (state) => (
  state.tentativeParents && state.tentativeParents.searchFeedback
    ? state.tentativeParents.searchFeedback.requesting || false
    : false
)
export const getTentativeParentsSearchError = (state) => (
  state.tentativeParents && state.tentativeParents.searchFeedback
    ? state.tentativeParents.searchFeedback.error || false
    : false
)

// Modal selectors
export const getShowParentErrorModal = (state) => {
  const tentativeParents = state.tentativeParents
  return tentativeParents ? tentativeParents.showParentErrorModal || false : false
}

export const getShowParentConfirmModal = (state) => {
  const tentativeParents = state.tentativeParents
  return tentativeParents ? tentativeParents.showParentConfirmModal || false : false
}

export const getSelectedParentForConfirmation = (state) => {
  const tentativeParents = state.tentativeParents
  return tentativeParents ? tentativeParents.selectedParentForConfirmation || null : null
}

export const getShouldShowParentSelectorModal = (state) => {
  const tentativeParents = state.tentativeParents
  return tentativeParents ? tentativeParents.shouldShowParentSelectorModal || false : false
}

// Utility selectors
export const getTentativeParentById = (state, parentId) => {
  const tentativeParents = getTentativeParents(state)
  return tentativeParents.find((parent) => (
    parent.parent && parent.parent.id === parentId
  ))
}

export const getFilteredTentativeParents = (state, searchTerm) => {
  const parents = getTentativeParents(state)
  if (!searchTerm) return parents
  
  return parents.filter(parent => {
    const user = parent.parent && parent.parent.user
    if (!user) return false
    
    const fullName = `${user.firstName || ''} ${user.lastName || ''}`.toLowerCase()
    const email = (user.email || '').toLowerCase()
    const searchTermLower = searchTerm.toLowerCase()
    
    return fullName.includes(searchTermLower) || email.includes(searchTermLower)
  })
}
